import * as React from 'react';
import RegisterInput from '../RegisterInput';
import AuthenticationLeftText from '../../../../components/ui/AuthenticationLeftText';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import src from '../../../../assets/images/modalbackground.png';
import responsiveSRC from '../../../../assets/images/responsivemodalbackground.png';

const AuthenticationModalContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '820px',
  height: '510px',
  dropShadow: '0px 4px 4px rgba(0, 0, 0, 0.3)',
  backgroundImage: `url(${src})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  p: 4,

  [theme.breakpoints.down('md')]: {
    backgroundImage: `url(${responsiveSRC})`,
    width: '400px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  [theme.breakpoints.down('400')]: {
    backgroundImage: `url(${responsiveSRC})`,
    width: '100%',
    height: '450px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  [theme.breakpoints.down('350')]: {
    backgroundImage: `url(${responsiveSRC})`,
    width: '310px',
    height: '350px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

const Shadow = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgba(0, 0, 0, 0)',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '510px',
    background: 'rgba(0, 0, 0, 0.5)',
  },

  [theme.breakpoints.down('400')]: {
    width: '100%',
    height: '450px',
    background: 'rgba(0, 0, 0, 0.5)',
  },

  [theme.breakpoints.down('350')]: {
    width: '310px',
    height: '350px',
    background: 'rgba(0, 0, 0, 0.5)',
  },
}));

const AuthenticationModalOutlinedBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '800px',
  height: '500px',
  border: '1px solid #AA9178',

  [theme.breakpoints.down('md')]: {
    width: '95%',
    height: '490px',
  },

  [theme.breakpoints.down('400')]: {
    width: '94%',
    height: '430px',
  },

  [theme.breakpoints.down('350')]: {
    width: '290px',
    height: '330px',
  },
}));

export default function RegisterModal(props) {
  return (
    <AuthenticationModalContainer>
      <Shadow>
        <AuthenticationModalOutlinedBox>
          <AuthenticationLeftText />
          <RegisterInput {...props} />
        </AuthenticationModalOutlinedBox>
      </Shadow>
    </AuthenticationModalContainer>
  );
}
